import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import NewsSection from './components/NewsSection';
import FaqSection from './components/FaqSection';
import TestimonialsSection from './components/TestimonialsSection';
import { useSEO } from '../../utils/seo';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://okayama-pet-funeral.example.com';

  useSEO({
    title: '岡山市のペット葬儀・火葬サービス｜小鳥から大型犬まで対応｜おかやまペット葬儀株式会社',
    description: '岡山市で20年以上の実績。大切な家族との最後のお別れを心を込めてサポート。小鳥、ハムスター、猫、小型犬から大型犬まで対応。個別火葬、合同納骨、永代供養、仏具販売。24時間365日対応可能。',
    keywords: '岡山市,ペット葬儀,ペット火葬,ペット納骨,大型犬,小型犬,猫,小鳥,ハムスター,永代供養,個別火葬,合同納骨,ペット仏具',
    canonical: `${siteUrl}/`,
    structuredData: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'LocalBusiness',
          '@id': `${siteUrl}/#organization`,
          name: 'おかやまペット葬儀株式会社',
          url: siteUrl,
          telephone: '+81-86-012-3456',
          faxNumber: '+81-86-012-3457',
          priceRange: '¥¥',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '○○町1-2-3',
            addressLocality: '岡山市北区',
            addressRegion: '岡山県',
            postalCode: '700-0000',
            addressCountry: 'JP',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: 34.6617,
            longitude: 133.935,
          },
          openingHoursSpecification: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            opens: '09:00',
            closes: '18:00',
          },
          founder: {
            '@type': 'Person',
            name: '岡山太郎',
          },
          foundingDate: '2000',
          numberOfEmployees: 9,
          areaServed: {
            '@type': 'City',
            name: '岡山市',
          },
          description: '岡山市で20年以上の実績を持つペット葬儀・火葬サービス。小鳥、ハムスター、猫、小型犬から大型犬まで対応。個別火葬、合同納骨、永代供養、仏具販売を提供。',
        },
        {
          '@type': 'Service',
          '@id': `${siteUrl}/#service`,
          serviceType: 'ペット葬儀・火葬サービス',
          provider: {
            '@id': `${siteUrl}/#organization`,
          },
          areaServed: {
            '@type': 'City',
            name: '岡山市',
          },
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'ペット葬儀サービス',
            itemListElement: [
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: '個別火葬サービス',
                },
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: '合同納骨・永代供養',
                },
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: '個別納骨サービス',
                },
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'ペット仏具販売',
                },
              },
            ],
          },
        },
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: 'おかやまペット葬儀株式会社',
          publisher: {
            '@id': `${siteUrl}/#organization`,
          },
        },
      ],
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <h1 className="sr-only">おかやまペット葬儀株式会社</h1>
      <HeroSection />
      <ServicesSection />
      <NewsSection />
      <FaqSection />
      <TestimonialsSection />
      <Footer />
    </div>
  );
};

export default HomePage;
